// src/pagesv2/user/UserProfile.jsx
import { useParams } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'
import { toast } from 'react-hot-toast'
import { useUserProfile } from '../../hooks/useUserProfile'
import { UserProfileDesktop } from './UserProfileDesktop'
import { UserProfileMobile } from './UserProfileMobile'
import { UserProfileHelmet } from '../../cmps/Helments/UserProfileHelmet'
import { Loader } from '../../cmps/FarmerMotion/Loader'

export function UserProfile() {
  const { username } = useParams()
  const isMobile = useMediaQuery({ maxWidth: 1024 })

  const {
    user,
    userId,
    reviews,
    comments,
    isLoading,
    error,
    recommendationsCount,
    disappointmentsCount,
    loggedInUser,
    isEditing,
    setIsEditing,
    activeTab,
    setActiveTab,
  } = useUserProfile(username)

  if (isLoading) return <Loader />

  if (error) return <div>שגיאה: {error}</div>
  if (!user) return <div>משתמש לא נמצא</div>

  const handleEdit = () => {
    try {
      setIsEditing(true)
    } catch (err) {
      console.error('Error opening edit profile:', err)
      toast.error('שגיאה בפתיחת הטופס לעריכה')
    }
  }

  const handleCloseEdit = () => {
    try {
      setIsEditing(false)
    } catch (err) {
      console.error('Error closing edit profile:', err)
      toast.error('שגיאה בסגירת הטופס לעריכה')
    }
  }

  const tabs = isMobile
    ? [
        { key: 'watchOrReadList', label: 'רשימת צפייה' },
        { key: 'userDetails', label: 'מידע אישי' },
        { key: 'userComments', label: 'תגובות' },
        { key: 'userReviews', label: 'דירוגים' },
        {
          key: 'userPosts',
          label: 'כתבות',
          condition: user?.posts?.length > 0,
        },
        {
          key: 'importMalList',
          label: 'ייבוא רשימה',
          condition:
            loggedInUser &&
            (loggedInUser._id === userId || loggedInUser.role === 'admin'),
        },
      ]
    : [
        { key: 'watchOrReadList', label: 'רשימת צפייה' },
        { key: 'userComments', label: 'תגובות' },
        { key: 'userReviews', label: 'דירוגים' },
        {
          key: 'userPosts',
          label: 'כתבות',
          condition: user?.posts?.length > 0,
        },
        {
          key: 'importMalList',
          label: 'ייבוא רשימה',
          condition:
            loggedInUser &&
            (loggedInUser._id === userId || loggedInUser.role === 'admin'),
        },
      ]

  const stats = [
    { label: 'המלצות', value: recommendationsCount },
    { label: 'אכזבות', value: disappointmentsCount },
    { label: 'תגובות', value: comments?.length },
  ]

  const commonProps = {
    user,
    userId,
    reviews,
    comments,
    loggedInUser,
    isEditing,
    handleEdit,
    handleCloseEdit,
    activeTab,
    setActiveTab,
    recommendationsCount,
    disappointmentsCount,
    tabs,
    stats,
  }

  return (
    <>
    
      <UserProfileHelmet user={user} />
      {isMobile ? (
        <UserProfileMobile {...commonProps} />
      ) : (
        <UserProfileDesktop {...commonProps} />
      )}
    </>
  )
}
